// extracted by mini-css-extract-plugin
module.exports = {"categoryButton":"ServiceFAQ_categoryButton__pcgvQ"};